export default {
    chatScript: ""
};